import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import TopNavBar from '../usercomponents/TopNavBar';
import Footer from '../usercomponents/Footer';
import SideBar from '../usercomponents/SideBar';
import ProtectedVideoPlayer from '../components/ProtectedVideoPlayer';
const apiUrl = process.env.REACT_APP_API_URL;
function CourseDetails() {
  const { batchid } = useParams();
  const [course, setCourse] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  useEffect(() => {
    console.log('Current URL:', window.location.href);
    console.log('URL parameters:', { batchid });
    console.log('Fetching course details for batch ID:', batchid);
    if (!batchid || batchid === 'undefined') {
      console.error('Invalid batch ID:', batchid);
      setError('Invalid batch ID. Please select a valid course.');
      setLoading(false);
      return;
    }
    const fetchCourseDetails = async () => {
      const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
      console.log('Session data:', sessionData);
      if (!sessionData || !sessionData.token || !sessionData.id) {
        console.error('Invalid session data:', sessionData);
        setError('Please login to view course details.');
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`${apiUrl}/api/student/course-details/${batchid}?nocache=${Date.now()}`, {
          headers: { Authorization: `Bearer ${sessionData.token}` }
        });
        console.log('Course details API response:', response.data);
        if (response.data.success) {
          setCourse(response.data.course);
          setLessons(response.data.lessons);
          if (response.data.lessons.length > 0) {
            setSelectedLesson(response.data.lessons[0]);
            if (!response.data.lessons[0].isRead) {
              await markLessonAsRead(response.data.lessons[0].id, sessionData.token);
            }
          }
        } else {
          setError(response.data.message || 'Failed to fetch course details.');
        }
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.response?.data?.message || 'Error fetching course details.');
      } finally {
        setLoading(false);
      }
    };
    fetchCourseDetails();
  }, [batchid]);
  // Record that this student opened the lesson video (shown to admins under Document Views).
  useEffect(() => {
    if (!selectedLesson) return;
    try {
      const session = JSON.parse(sessionStorage.getItem('studentSession'));
      if (!session?.token) return;
      axios.post(`${apiUrl}/api/student/lesson-view`, { lessonId: selectedLesson.id }, {
        headers: { Authorization: `Bearer ${session.token}` },
      }).catch(() => {});
    } catch (e) {
      /* logging never blocks watching */
    }
  }, [selectedLesson?.id]);

  const markLessonAsRead = async (lessonId, token) => {
    try {
      const response = await axios.post(`${apiUrl}/api/student/mark-lesson-read`, { lessonId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('Mark lesson read response:', response.data);
      setLessons(prevLessons =>
        prevLessons.map(lesson =>
          lesson.id === lessonId ? { ...lesson, isRead: true } : lesson
        )
      );
    } catch (err) {
      console.error('Error marking lesson as read:', err);
    }
  };
  const handleLessonClick = async (lesson) => {
    setSelectedLesson(lesson);
    if (!lesson.isRead) {
      const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
      await markLessonAsRead(lesson.id, sessionData.token);
    }
  };
  const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = url.split('v=')[1]?.split('&')[0] || url.split('be/')[1]?.split('?')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    } else if (url.includes('vimeo.com')) {
      const videoId = url.split('vimeo.com/')[1]?.split('?')[0];
      return `https://player.vimeo.com/video/${videoId}`;
    }
    return url;
  };
  const openPdfModal = (file) => {
    setSelectedPdf(file);
    setPdfModalOpen(true);
  };
  const closePdfModal = () => {
    setPdfModalOpen(false);
    setSelectedPdf(null);
  };
  if (loading) return <div>Loading...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb mb-24">
            <ul className="flex-align gap-4">
              <li>
                <Link
                  to="/student-dashboard"
                  className="text-gray-200 fw-normal text-15 hover-text-main-600"
                >
                  LMS
                </Link>
              </li>
              <li>
                <span className="text-gray-500 fw-normal d-flex">
                  <i className="ph ph-caret-right" />
                </span>
              </li>
              <li>
                <span className="text-main-600 fw-normal text-15">Course</span>
              </li>
              <li>
                <span className="text-gray-500 fw-normal d-flex">
                  <i className="ph ph-caret-right" />
                </span>
              </li>
              <li>
                <span className="text-main-600 fw-normal text-15">Course Details</span>
              </li>
            </ul>
          </div>
          <div className="row gy-4">
            <div className="col-md-8">
              <div className="card">
                <div className="card-body p-lg-20 p-sm-3">
                  <div className="flex-between flex-wrap gap-12 mb-20">
                    <div>
                      <h3 className="mb-4">{course?.coursename || 'Course Title'}</h3>
                      <p className="text-gray-600 text-15">IFM Edu Academy</p>
                    </div>
                    <div className="flex-align flex-wrap gap-24">
                      <span className="py-6 px-16 bg-main-50 text-main-600 rounded-pill text-15">
                        IFM Course
                      </span>
                      <div className="share-social position-relative">
                        <button
                          type="button"
                          className="share-social__button text-gray-200 text-26 d-flex hover-text-main-600"
                        >
                          <i className="ph ph-share-network" />
                        </button>
                        <div className="share-social__icons bg-white box-shadow-2xl p-16 border border-gray-100 rounded-8 position-absolute inset-block-start-100 inset-inline-end-0">
                          <ul className="flex-align gap-8">
                            <li>
                              <a
                                href="https://www.facebook.com"
                                className="flex-center w-36 h-36 border border-main-600 text-white rounded-circle text-xl bg-main-600 hover-bg-main-800 hover-border-main-800"
                              >
                                <i className="ph ph-facebook-logo" />
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.google.com"
                                className="flex-center w-36 h-36 border border-main-600 text-white rounded-circle text-xl bg-main-600 hover-bg-main-800 hover-border-main-800"
                              >
                                <i className="ph ph-twitter-logo" />
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.twitter.com"
                                className="flex-center w-36 h-36 border border-main-600 text-white rounded-circle text-xl bg-main-600 hover-bg-main-800 hover-border-main-800"
                              >
                                <i className="ph ph-linkedin-logo" />
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.instagram.com"
                                className="flex-center w-36 h-36 border border-main-600 text-white rounded-circle text-xl bg-main-600 hover-bg-main-800 hover-border-main-800"
                              >
                                <i className="ph ph-instagram-logo" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="bookmark-icon text-gray-200 text-26 d-flex hover-text-main-600"
                      >
                        <i className="ph ph-bookmarks" />
                      </button>
                    </div>
                  </div>
                  {selectedLesson && (
                    <ProtectedVideoPlayer
                      youtubeLink={selectedLesson.youtube_link}
                      session={JSON.parse(sessionStorage.getItem('studentSession') || 'null') || {}}
                    />
                  )}
                  {selectedLesson && (
                    <div className="mt-24">
                      <div className="mb-24 pb-24 border-bottom border-gray-100">
                        <h5 className="mb-12 fw-bold">Lesson Summary</h5>
                        <p className="text-gray-300 text-15">
                          {selectedLesson.summary || 'No summary available.'}
                        </p>
                      </div>
                      <div className="mb-24 pb-24 border-bottom border-gray-100">
                        <h5 className="mb-12 fw-bold">Related Files</h5>
                        {selectedLesson.files.length > 0 ? (
                          <ul>
                            {selectedLesson.files.map((file) => (
                              <li key={file.id}>
                                <a
                                  href={`${apiUrl}/${file.filepath}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {file.title}
                                </a>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p>No files available for this lesson.</p>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="mb-24 pb-24 border-bottom border-gray-100">
                    <h5 className="mb-12 fw-bold">About this course</h5>
                    <p className="text-gray-300 text-15">
                      {course?.coursesummary || 'No summary available.'}
                    </p>
                  </div>
                 
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-body p-0">
                  <div className="course-item">
                    <button
                      type="button"
                      className="course-item__button active flex-align gap-4 w-100 p-16 border-bottom border-gray-100"
                    >
                      <span className="d-block text-start">
                        <span className="d-block h5 mb-0 text-line-1">
                          Course Lessons
                        </span>
                        <span className="d-block text-15 text-gray-300">
                          {lessons.length} Lessons
                        </span>
                      </span>
                      <span className="course-item__arrow ms-auto text-20 text-gray-500">
                        <i className="ph ph-arrow-right" />
                      </span>
                    </button>
                    <div className="course-item-dropdown active border-bottom border-gray-100">
                      <ul className="course-list p-16 pb-0">
                        {lessons.map((lesson) => (
                          <li
                            key={lesson.id}
                            className={`course-list__item flex-align gap-8 mb-16 ${selectedLesson?.id === lesson.id ? 'active' : ''}`}
                          >
                            <span className="circle flex-shrink-0 text-32 d-flex text-gray-100">
                              {lesson.isRead ? (
                                <i className="ph ph-check-circle text-success-600" />
                              ) : (
                                <i className="ph ph-circle" />
                              )}
                            </span>
                            <div className="w-100">
                              <a
                                onClick={() => handleLessonClick(lesson)}
                                className="text-gray-300 fw-medium d-block hover-text-main-600 d-lg-block"
                                style={{ cursor: 'pointer' }}
                              >
                                {lesson.title}
                                <span className="text-gray-300 fw-normal d-block">
                                  {lesson.summary || 'No summary available'}
                                </span>
                              </a>
                            </div>
                          </li>
                        ))}
                        {lessons.length === 0 && <p>No lessons available.</p>}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default CourseDetails;